var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"storeList"},_vm._l((_vm.list),function(item){return _c('ServiceStoreItem',{key:item.id,staticClass:"discountServiceItem",attrs:{"item":item},on:{"onClickItem":function($event){return _vm.onGoToStoreHome(item)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }